exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".template-preview[data-v-9cd1545a]{width:490px;height:635px;border:0;overflow-x:hidden}\n", ""]);

